export default {
  items: []
}



// WEBPACK FOOTER //
// ./src/store/modules/invoices/state.js